import Summary from '../../../../components/generic-summary/generic-summary.desktop';
import upsellingMeliplusSummary from './upselling-meliplus-summary';

export default upsellingMeliplusSummary(Summary);
